import LocalizedStrings from "react-localization";
import { images } from "../common/Images";

let String = new LocalizedStrings({
  en: {
    header_text: {
      login: "Login",
      sign_up: "Sign Up",
      customer_name: "Customer Name",
      customer_id: "Customer ID",
      list: [
        "Diamond",
        "Gold",
        "Silver",
        "Gemstone",
        "Gold Coin",
        "Gold Bar",
        "Silver Coin",
        "Silver bar",
      ],
    },
    footer_text: {
      col_1: {
        title: "Categories",
        diamond: "Diamond",
        gold: "Gold",
        silver: "Silver",
        platinum: "Platinum",
      },
      col_2: {
        title: "Company",
        new_arrivals: "New Arrivals",
        offers: "Offers",
        earrings: "Earrings",
        necklace: "Necklace",
        exclusive:"Exclusive Designs"
      },
      col_3: {
        title: "Policies",
        privacy_policy: "Privacy Policy",
        terms_of_use: "Terms & Conditions",
        conditions: "Conditions",
        return_policy: "Return Policy",
        shipping_olicy :"Shipping Policy"
      },
      col_4: {
        title: "Contact Us",
        text: "To solidify our knowledge about CSS variables, we’ll build two very simple projects.",
      },
      download_our_app: "Download Our App",
      download_on_the_app_store: "Download on the App Store",
      download_on_the_play_Store: "Download on the Play Store",
      all_rights_reserved: "All rights reserved",
    },
    home_box: [
      {
        icon: images.offer_new,
        text: "Attractive",
        last_text: "Offers Up to 90%",
      },
      {
        icon: images.delivery_van,
        text: "Delivery",
        last_text: "At Your Door Steps",
      },
      {
        icon: images.wallet_new,
        text: "Payments",
        last_text: " Cash / Card",
      },
      {
        icon: images.grocery,
        text: "Wide Rage",
        last_text: "Of Products",
      },
    ],
    home_headings: {
      search: "Search",
      discover_our_collections: "Discover our Collections",
      view_all_collections: "View All Collections",
      shop_on_budget: "Shop on Budget",
      meet_our_best_sellers: "Meet Our Best Sellers",
      best_price_and_unique_design_makers:
        "Best Price and Unique Design Makers",
      show_more: "Show More",
      shop_our_exclusives: "Shop Our Exclusives",
      our_exclusive_collections: "Our Exclusive Collections!",
      latest_trending: "Latest Trending",
      Shop_by_categories: "Shop By Categories",
      best_offers: "Best Offers",
      promo_videos: "Promo Videos",
      best_light_weight_collections: "Best Light Weight Collections..!",
      Ccustomer_review: "Customer Review",
    },
    our_collection: {
      explore_collections: "Explore Collections",
    },
    login: {
      enter_email: "Enter Your Email",
      valid_email: "Enter valid Email",
      enter_password: "Enter Your Password",
      phone_requried: "Phone Number Required",
    },
    contact: {
      first_required: "First Name is required",
      first_min: "First Name must be minimun 8 characters",
      last_required: "Last name is required",
      enter_email: "Email ID is required",
      valid_email: "Email ID is invalid",
      phone_requried: "Mobile number is required",
      phone_valid: "Mobile number is invalid",
      phone_min: "Mobile number must be minimun 10 numbers",
      phone_max: "Mobile number must be maximun 13 numbers",
      valid_phone: "Mobile number is invalid",
      message_required: "Message is required",
      message_min: "Message must be 10 characters",
    },
    profile: {
      first_required: "First Name is required",
      last_required: "Last name is required",
      phone_requried: "Mobile number is required",
      enter_email: "Email ID is required",
      valid_email: "Email ID is invalid",
      phone_valid: "Mobile number is invalid",
      phone_min: "Mobile number must be minimun 10 numbers",
      phone_max: "Mobile number must be maximun 13 numbers",
      valid_phone: "Mobile number is invalid",
      already_exist:"Same phone number cannot be updated"
    },
  },
});

export default String